document.querySelectorAll('a[href^="#"]').forEach((anchor)=>{
    anchor.addEventListener("click", function(e) {
        e.preventDefault();
        e.target.blur();
        const target = document.querySelector(this.getAttribute("href"));
        target.scrollIntoView({
            behavior: "smooth"
        });
        target.focus();
    });
});

//# sourceMappingURL=index.ad9d9a16.js.map
